import { ProvinceListPage } from "@/features/geolocation/page/ProvinceList";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/geolocation/province/")({
  component: ProvinceListPage,
});
